<template>
    <span class="route-itinerary" :class="{ 'route-itinerary--wrap': wrap }" :title="fullText">
        <template v-for="(segment, index) in visibleSegments">
            <v-icon v-if="index > 0" :key="`arrow-${index}`" x-small class="route-itinerary__arrow">
                mdi-arrow-right
            </v-icon>
            <span v-if="segment.more" :key="`more-${index}`" class="route-itinerary__more">… +{{ segment.more }}</span>
            <span v-else :key="`seg-${index}`" class="route-itinerary__segment"
                :class="{ 'route-itinerary__segment--stop': segment.stop }">
                <v-icon v-if="segment.stop" x-small class="route-itinerary__stop-icon">mdi-map-marker-path</v-icon>
                {{ segment.label }}
            </span>
        </template>
        <span v-if="!visibleSegments.length">{{ fallback || 'N/A' }}</span>
    </span>
</template>

<script>
// Itinerário da OS montado pela rota (embarques → paradas → desembarques),
// vindo da API em `route_itinerary` ({ segments: [{ label, stop }], text }).
// Rotas longas são resumidas; o texto completo fica no title.
export default {
    name: 'RouteItinerary',
    props: {
        itinerary: { type: Object, default: null },
        fallback: { type: String, default: '' },
        max: { type: Number, default: 5 },
        wrap: { type: Boolean, default: false }
    },
    computed: {
        segments() {
            return (this.itinerary && this.itinerary.segments) || []
        },
        visibleSegments() {
            const list = this.segments
            if (!this.max || list.length <= this.max) return list

            const head = list.slice(0, this.max - 2)
            const hidden = list.length - head.length - 1

            return [...head, { more: hidden }, list[list.length - 1]]
        },
        fullText() {
            return (this.itinerary && this.itinerary.text) || this.fallback || ''
        }
    }
}
</script>

<style lang="scss">
.route-itinerary {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 2px;
    max-width: 100%;
    overflow: hidden;

    &--wrap {
        flex-wrap: wrap;
    }
}

.route-itinerary__segment {
    white-space: nowrap;
}

.route-itinerary__segment--stop {
    color: #e65100;
    font-weight: 600;
}

.route-itinerary__stop-icon.v-icon {
    color: #e65100 !important;
    margin-right: 1px;
}

.route-itinerary__arrow.v-icon {
    color: #9aa5b8 !important;
    margin: 0 2px;
}

.route-itinerary__more {
    color: #5a6b85;
    white-space: nowrap;
}
</style>
